window.onload = function() {

  var neueNavToggle = document.getElementById('nav-toggle');

  if (neueNavToggle){
    neueNavToggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (document.body.classList.contains('nav-open')) {
        document.body.classList.remove('nav-open');
      } else {
        document.body.classList.add('nav-open');
      }

      if (!document.body.classList.contains('nav-opened')) {
        document.body.classList.add('nav-opened');
      }
    });
  }
};
